import {useState} from "react";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Circle
} from "@mui/icons-material";

export const NodeLegendPanel = ({nodes, colorMap, visibleNodes, nodeActiveStatus, onToggleNode}) => {
  const [expanded, setExpanded] = useState(true);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Paper
      elevation={1}
      className={"border-shadow"}
      sx={{
        position: "absolute",
        bottom: 16,
        left: 16,
        borderRadius: 5,
        maxWidth: "300px",
        width: "90%",
        maxHeight: "40dvh",
        zIndex: 100,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2, py: 1,
          borderBottom: expanded ? 1 : 0,
          borderColor: "divider",
          bgcolor: "background.paper"
        }}
      >
        <Typography variant="subtitle1" fontWeight="medium">
          Node Types
        </Typography>
        <IconButton size="small" onClick={handleToggle}>
          {expanded ? <ExpandMore /> : <ExpandLess />}
        </IconButton>
      </Box>

      {/* Collapsible Content */}
      <Collapse in={expanded} timeout="auto">
        <List
          sx={{
            maxHeight: "calc(40dvh - 48px)",
            overflow: "auto",
            py: 0
          }}
        >
          {nodes.map((nodeType) => {
            const isVisible = visibleNodes[nodeType] !== false;
            const isActive = nodeActiveStatus?.get(nodeType) !== false;
            const colorObj = colorMap.get(nodeType) || {background: "#999999"};

            // If node is not active, use grey colors
            const color = isActive ? (colorObj.background || "#999999") : "grey.300";
            const textColor = isActive ? "text.primary" : "grey.800";

            return (
              <ListItem key={nodeType} disablePadding>
                <ListItemButton
                  onClick={() => onToggleNode(nodeType)}
                  sx={{
                    py: 1,
                    px: 2,
                    "&:hover": {
                      bgcolor: "action.hover"
                    }
                  }}
                >
                  <ListItemIcon sx={{minWidth: 40}}>
                    <Circle
                      sx={{
                        fontSize: 20,
                        color: isVisible ? color : "#cccccc"
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={nodeType}
                    primaryTypographyProps={{
                      sx: {
                        textDecoration: isVisible ? "none" : "line-through",
                        color: isVisible ? textColor : "text.disabled"
                      }
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </Paper>
  );
};